export const Mixed = 0
export const Automatic = 1
export const Enforced = 2
